import { DIC } from "@/const/dic";

export const warehousingOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  selection: true,
  // viewBtn: false,
  columnBtn: false,
  // gutter: 180,
  menuWidth: "300",
  // labelPosition: 'top',
  labelWidth: "150",
  // menuType:'menu',

  column: [
    {
      label: "商品名称",
      prop: "name",
      type: "input",
      span: 13,
      search: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请输入商品名称"
      // }]
    },

    // {
    //     label: '产品型号',
    //     prop: 'type',
    //     type: "input"
    // },

    {
      label: "品牌名称",
      prop: "brandName",
      span: 13,
      formsolt: true,
    },
    {
      label: "商品单位",
      prop: "unit",
      span: 13,
      type: "input",
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请输入商品单位"
      // }]
    },
    {
      label: "一级分类",
      prop: "firstClassifyName",
      span: 12,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请选择一级分类"
      // }]
    },
    {
      label: "二级分类",
      prop: "secondClassifyName",
      span: 12,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请选择二级分类"
      // }]
    },
    {
      label: "SKU组合",
      prop: "sku",
      hide: true,
      span: 13,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请选择SKU"
      // }]
    },
    {
      label: "商品属性和价格",
      labelPosition: "top",
      prop: "constitute",
      span: 24,
      solt: true,
      hide: true,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请选择SKU"
      // }]
    },
    {
      label: "商品属性和价格",
      labelPosition: "top",
      prop: "constitutes",
      span: 24,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
      hide: true,
    },
    // {
    //     label: '商品状态',
    //     prop: 'status',
    //     solt: true,
    //     span: 13,
    //     formsolt: true,
    //     addVisdiplay:false
    // },
    {
      label: "商品状态",
      prop: "status",
      type: "radio",
      solt: true,
      dicData: DIC.INVOICE_SYSTEN_PUT_STATUS,
      valueDefault: "SOLD_IN",
      addVisdiplay: true,
    },
    // {
    //     label: '商品状态',
    //     prop: 'goodsStatus',
    //     type: "radio",
    //     hide: true,
    //     dicData: DIC.PRODUCT_WAREHOUSING_STATUS,
    //     valueDefault: 'PUTAWAY',
    //     addVisdiplay: true
    // },
    {
      label: "总入库量",
      prop: "allAmount",
      span: 13,
      type: "input",
      editVisdiplay: false,
      addVisdiplay: false,
    },
    {
      label: "现有库存",
      prop: "amount",
      span: 13,
      type: "input",
      editVisdiplay: false,
      addVisdiplay: false,
    },
    {
      label: "商品主图",
      prop: "mainImage",
      span: 24,
      hide: true,
      solt: true,
      formsolt: true,
    },
    {
      label: "商品详情",
      prop: "describes",
      span: 24,
      hide: true,
      solt: true,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请点击上传商品详情图片"
      // }]
    },
    {
      label: "商品轮播",
      prop: "wheels",
      span: 24,
      solt: true,
      hide: true,
      formsolt: true,
      // rules: [{
      //     required: true,
      //     trigger: "blur",
      //     message: "请点击上传不超过5张的商品轮播图片"
      // }]
    },
  ],
};
